import React from 'react';

import { StorageOfUniqueComponents } from '@qality/common-service';

import './_test-execution-details.scss';

type Props = {
  label: string;
  columnName: string;
  additionalClassName?: string;
};

function TestExecutionTableTestExecutionHeader({
  label,
  columnName,
  additionalClassName = '',
}: Props): JSX.Element {
  const TestExecutionColumnsWidth = StorageOfUniqueComponents.get(
    'TestExecutionColumnsWidth'
  );
  return (
    <div
      className='column-header column-header-execution'
      style={{
        ...(TestExecutionColumnsWidth[columnName] === '0%' && { minWidth: 0 }),
        width: TestExecutionColumnsWidth[columnName],
      }}
    >
      <h5 className={'test-execution-header-label ' + additionalClassName}>
        {label}
      </h5>
    </div>
  );
}

export default TestExecutionTableTestExecutionHeader;
